import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { StoragesService } from './storage.service';

import { FileElm } from 'src/app/utils/interfaces';
import { map, Subscription } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import {
  IStorageConfirmationModalDefault,
  StorageConfirmationModalComponent
} from './storage-confirmation-modal/storage-confirmation-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-storage',
  templateUrl: './storage.component.html',
  styleUrls: ['./storage.component.scss']
})
export class StorageComponent implements OnInit, AfterViewInit, OnDestroy {
  public storageStats = this.storage.storageStat.value();

  public data = new MatTableDataSource<FileElm>();
  public displayedColumns: (keyof FileElm | 'action')[] = ['id', 'name', 'createdAt', 'size', 'encrypted', 'hasRef', 'hasFile', 'action'];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  private $file: Subscription;

  constructor(private dialog: MatDialog, private storage: StoragesService, private snackBar: MatSnackBar) {
    this.$file = this.storage.file.pipe(map((data) => (this.data.data = data))).subscribe();
    return;
  }

  public ngOnInit(): void {
    return;
  }

  public ngAfterViewInit(): void {
    this.data.paginator = this.paginator;
    this.data.sort = this.sort;
  }

  public ngOnDestroy(): void {
    this.$file.unsubscribe();
  }

  public refresh(): void {
    this.storage.refreshStorageInfo();
  }

  public encrypt(file: FileElm): void {
    this.storage.encrypt(file).subscribe({
      next: () => {
        this.snackBar.open(`Le fichier ${file.name} a été encrypté`, 'close', { duration: 2000 });
      },
      error: () => {
        this.snackBar.open(`Un erreur est survenu lors de l'encryption du fichier ${file.name}`, 'close', { duration: 2000 });
      }
    });
  }

  public download(file: FileElm): void {
    this.storage.download(file.id).subscribe({
      next: ({ blob, filename }) => {
        const a = document.createElement('a');
        const objectUrl = window.URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(objectUrl);
      }
    });
  }

  public addDescription(file: FileElm): void {
    this.storage.createDescription(file).subscribe({
      next: () => {
        this.snackBar.open(`La description fichier ${file.name} a été ajouté`, 'close', { duration: 2000 });
      },
      error: () => {
        this.snackBar.open(`Un erreur est survenu lors de la création de la description du fichier ${file.name}`, 'close', { duration: 2000 });
      }
    });
  }

  public remove(file: FileElm): void {
    const dialog = this.dialog.open<StorageConfirmationModalComponent, IStorageConfirmationModalDefault, boolean>(StorageConfirmationModalComponent, {
      minWidth: 800,
      maxWidth: 800,
      data: { file }
    });

    dialog.afterClosed().subscribe((state) => {
      if (state)
        this.storage.remove(file.id).subscribe({
          next: () => {
            this.snackBar.open(`Le fichier ${file.name} a été supprimer`, 'close', { duration: 2000 });
          }
        });
    });
  }
}
